// @ts-nocheck
import React from "react";
import { FC } from "react";
import { useMemo } from "react";
import Container from "@material-ui/core/Container";
import PageHeader from "../../../../components/PageHeader";
import SchoolCard from "../../components/front/SchoolCard";
import { SchoolCardsProvider } from "../../components/front/SchoolCard/context";
import { useSchoolCards } from "../../components/front/SchoolCard/context";
import Error from "../../../../components/Error";
import { mutateErrors } from "../../../../utils";

const FavoritesPage: FC = () => {
  return (
    <>
      <Container maxWidth="lg">
        <PageHeader
          title={"Favorite Schools"}
          subtitle={"Here are listed your favorite schools"}
        />
      </Container>
      <Container maxWidth="lg">
        <SchoolCardsProvider>
          <FavoritesList />
        </SchoolCardsProvider>
      </Container>
    </>
  );
};

const FavoritesList: FC = React.memo(() => {
  const { favorites, userFavorites } = useSchoolCards();

  const list = useMemo(
    () =>
      userFavorites.data
        ? userFavorites.data.data.filter((item) => favorites.includes(item.id))
        : [],
    [favorites],
  ); // eslint-disable-line react-hooks/exhaustive-deps

  if (userFavorites.isError) {
    const { message } = mutateErrors(userFavorites.error);
    return <Error icon={"search"} text={message} />;
  }

  if (!list.length)
    return <Error icon={"heart"} text={"You have no results for now."} />;

  return (
    <>
      {list.map((item) => (
        <SchoolCard key={item.id} title={item.name} school={item}>
          {item.description}
        </SchoolCard>
      ))}
    </>
  );
});

export default React.memo(FavoritesPage);
